import { render } from "./homeslide3.vue?vue&type=template&id=3644d488&scoped=true"
import script from "./homeslide3.vue?vue&type=script&lang=js"
export * from "./homeslide3.vue?vue&type=script&lang=js"

import "./homeslide3.vue?vue&type=style&index=0&id=3644d488&scoped=true&lang=less"

import exportComponent from "/Users/zhoubenhao/Desktop/行云/numatch/numatch-home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3644d488"]])

export default __exports__